export default {
	base: {
		search: '搜索',
		advance_search: '高级搜索',
		reset: '重置',
		min: '最小值',
		max: '最大值',
		to: '至',
		no_pictures: '暂无图片',
		add: '新增',
		add1: '+ 新增',
		to_view: '查看',
		edit: '编辑',
		edit1: '修改',
		delete: '删除',
		copy: '复制',
		copying: '复制中...',
		operation: '操作',
		save: '保存',
		confirm: '确认',
		done: '确定',
		cancel: '取消',
		success: '成功',
		fail: '失败',
		delete_alert_role_title: '删除失败！',
		delete_alert_role_info: '该角色下包含用户信息，请删除该角色下的所有用户或解绑该角色后才能删除！',
		delete_alert_title: '确定删除',
		delete_alert_info: '此操作不可撤回！',
		delete_alert_completed: '已删除',
		copy_alert_title: '确定复制该条数据？',
		add_success: '创建成功',
		edit_success: '编辑成功',
		delete_success: '删除成功',
		copy_success: '复制成功',
		search_id: '搜索',
		upload_file_limit: '只可上传jpg/png文件，且不超过50M',
		upload_picture_limit: '只可上传jpg/png文件，且不超过50M',
		upload_excel_limit: '只可上传Excel文件，且不超过50M',
		no_data: '暂无数据',
		hint_name: '名称不能为空！',
		none: '无',
		total: '合计',
		total_unit: '条',
		previous_page: '上一页',
		next_page: '下一页',
		jump_to: '跳转至',
		jump_to_unit: '页',
		empty: '暂无数据',
		disabled: '不可用',
		enabled: '可用',
		request403: '没有登录或没有权限',
		request403_to_login: '登录状态失效，3s后跳转至登录页',
		grant_all_garment: '服装编辑',
		grant_all_garment_view: '服装仅查看',
		grant_all_fabric: '织物编辑',
		grant_all_fabric_view: '织物仅查看',
		grant_all_yarn: '纱线编辑',
		grant_all_yarn_view: '纱线仅查看',
		grant_all_fibre: '纤维编辑',
		grant_all_fibre_view: '纤维仅查看',
		grant_all_textile_bedware: '床上用品编辑',
		grant_all_textile_bedware_view: '床上用品仅查看',
		grant_all_textile_home_decor: '普通家用纺织品编辑',
		grant_all_textile_home_decor_view: '普通家用纺织品仅查看',
		grant_all_textile_industrial: '产业纺织品编辑',
		grant_all_textile_industrial_view: '产业纺织品编辑',
		grant_all_textile_kitchen: '厨卫用品编辑',
		grant_all_textile_kitchen_view: '厨卫用品仅查看',
		english: 'English',
		chinese: '中文',
		preview: '预览',
		is_public: '公开',
		user_info: '个人信息',
		user_center_name: "用户名",
		change_password: "修改密码",
		original_password: "原始密码",
		new_password: '新密码',
		confirm_password: '确认密码',
		confirm_password_info: '两次输入的密码不一致',
		change_success: '修改成功',
		filter_password: '新密码与原始密码一致,请重新修改',
		hint_code: '品目编码为必选项',
		No: '序号',
		resetFile: '上传新文件将会覆盖原有文件，是否继续?',
		show: '显示',
		requiredinformation: '请填写所有必填信息',
		delete_alert_hscode_info: '该code下包含子集信息，请先删除该code下的所有子集信息再删除本条code！',
		delete_alert_error_title: '错误信息',
		alert_message_info: '提示信息',
		requireGroupAndindicator: '请填写组名称和指标信息',
		requireIndicator: '请填写指标名称',
		sameIndicator: '同组内指标名称重复',
		viewDetails: '查看详情',
		cannotEdit: '系统预设内容不能修改',
		noDetailedInfo: '未查询到其详细信息',
		quantity: '数量',
		needInfo: '是否适用为是的时候，需要填些阈值和达标方式',
		start_date: '开始日期',
		end_date: '结束日期',
		permanent: '永久',
	},
	upload: {
		title: '将文件拖放到此处或单击上传',
		title1: '点击上传图片、视频和文档',
		limit: '上传文件大小限制：',
		limit1: '文件大小不超过',
		type: "支持PPT、PDF、EXCEL、WORD、PNG、JPEG、JPG、MP4、MOV",
		type1: '支持Excel、Word、PDF、PNG、JPEG、JPG，文件大小不超过50M',
		typeImage: "支持PNG、JPEG、JPG",
		typeExcel: "支持Excel文件格式",
		typeWordPdf: "支持PDF、WORD、图片文件格式",
		btn: '上传',
		notSameFile: '相同名字文件已存在，不能重复上传!',
		notCorrectType: '请上传正确的文件类型',
		notCorrectType1: '请上传正确的文件类型,支持Excel、Word、PDF、PNG、JPEG、JPG，文件大小不超过50M',
		file: '文件',
		uploadedFile: '已上传文件',
		uploadedFile1: '请上传文件',
		uploadedFile1Imag: '点击上传图片',
		uploadSuccess: '上传成功',
		fileSizeLimit: '超出上传文件大小限制50M',
		fileTypeLimit: '请上传图片或PDF',
		fileTypeLimit1: '支持 PDF、PNG、JPGE文件格式，文件大小不超过 50M',
		fileTypeLimit2: '支持 PNG、JPGE文件格式，文件大小不超过 50M',
		noUpload: '未上传',
	},
	menu: {
		home: '主页',
		garment: '服装数据库',
		fabric: '织物数据库',
		yarn: '纱线数据库',
		fiber: '纤维数据库',
		hometextile: '家纺数据库',
		textile_bedware: '床上用品数据库',
		textile_home_decor: '普通家用纺织品数据库',
		textile_industrial: '产业纺织品数据库',
		textile_kitchen: '厨卫用品数据库',
		textile: '产业纺织品数据库',
		system_management: '系统管理',
		product_template: '产品数据库管理',
		hscode_management: 'HS Code管理',
		role: '角色',
		user: '用户',
		permission: '权限',
		my: '我的',
		account: '企业账户管理',
		product_line: '产品线管理',
		product: '产品管理',
		business_information_management: '商业用户管理',
		business_products_management: '产品认证管理',
		supplyChain: '供应链管理',
		lang: '语言配置',
	},
	home: {
		title: 'FBD—纺织产业链大数据技术平台',
		supplier: "供应商",
		customers: "客户",
		products: "产品",
		market: "市场",
		inventory: "库存",
		quality: "质量",
		comfort: "感官舒适性",
		traceability: "可追溯性",
		circularity: "循环性",
		GHG: "环境足迹",
		social: "ESG",
	},
	attribute: {
		base: '基本信息',
		other: '其他信息',
		indicat: '可追溯性指标',
		value: '值',
		defaultvalue: '默认值',
		unit: '单位',
		id: 'ID',
		name: '名称',
		type: '类型',
		size: '尺码',
		size1: '尺寸',
		brand: '品牌',
		brand_name: '品牌名称',
		supplier: '供应商',
		cost: '成本',
		price: '价格',
		price_unit: '欧元/件',
		price_unit1: '欧元/吨',
		stock: '库存',
		stock_unit: '件',
		stock_unit1: '吨',
		style: '款式',
		fitting: '合身度',
		code: '品目编码',
		structure: '结构',
		safety: '安全',
		protection: '防护',
		features: '功能',
		others: '其他',
		composition: '组成结构',
		designer: '设计师',
		body_coverage_ratio: '人体覆盖率',
		manufacturer: '生产商',
		picture: '图片',
		water_contact_angle: '水接触角',
		water_contact_angle_unit: 'deg',
		percentage: '%',
		number: '编号',
		diameter: '直径',
		density: '密度',
		radius: '半径',
		phase_change_material_add_on_level: '相变材料添加量',
		latent_heat_of_fusion: '融化潜热',
		latent_heat_of_fusion_unit: 'cal/g',
		melting_point: '融化温度',
		thermal_conductivity_of_liquid_pcm: '液态相变材料热导率',
		thermal_conductivity_of_siquid_pcm: '固态相变材料热导率',
		heat_trnasfer_coefficient: '热传导系数',
		cm: 'cm',
		density_unit: 'g/m3',
		deg: 'deg',
		thermal_conductivity_unit: 'cal/s/cm/deg',
		heating_load: '热负荷',
		heating_load_unit: 'cal/s/cm3',
		switch_on_temperature: '开启温度',
		switch_off_temperature: '关闭温度',
		switch_off_temperature_unit: 'cal/s/cm3',
		water_vapor_permeability: '水蒸气透过性',
		thermal_resistance: '热阻',
		temperature: '温度',
		membrane_thickness: '膜厚度',
		membrane_type: '膜类型',
		membrane_location: '膜位置',
		tensile_properties: '拉伸性能',
		permeability: '透气性',
		tensile_stress: '拉伸应力',
		tensile_strain: '拉伸应变',
		pressure_range: '气压',
		flow_rate: '流速',
		feel_skin: '手感和皮肤舒适度',
		heat_simulation: '热湿舒适度-模拟设定',
		heat_file: '热度舒适度dat文件',
		version_2d: '2D版型',
		fitting_virtual: '虚拟合身度',
		fitting_virtual_link: '虚拟合身度超链接',
		body_virtual: '虚拟人体舒适度',
		body_virtual_link: '虚拟人体舒适度超链接',
		show_virtual: '虚拟展示',
		show_virtual_link: '虚拟展示超链接',
		last_time: '更新时间',
		description: '描述',
		status: '状态',
		upload_logo: '上传logo',
		role: '角色',
		role_name: '角色名称',
		parent_role: '父角色',
		user_name: '用户名称',
		password: '密码',
		organization: '组织',
		department: '部门',
		phone: '手机号码',
		email: '邮箱',
		create_time: '创建时间',
		just_fit: '合身',
		tight_fit: '紧身',
		loose_fit: '宽松',
		comfortable: '舒适性指标',
		quality: '质量指标',
		quality1: '质量',
		business: '商业指标',
		environment: '环境指标',
		shell: '外层',
		interlayer: '夹层',
		lining: '内衬',
		reference: '参考标准',
		indicators_related: '指标关联',
		indicator_name: '指标名称',
		please_set_hscode: '请先设置6位品目编码',
		indicator_related_confirm: '此操作将会修改该品目编码下的所有指标显示和参考标准，是否确认？',
		search_indicator_name: '搜索指标名称',
		indicatorstandards: '指标标准',
		database: '资料库',
		datauploaded: '已上传资料',
		uploadMessage: 'HS Code相关图、视频、文档',
		addGroup: '添加组',
		video: '视频',
		document: '文档',
		qualityInspectionReport: '质检报告',
		pid: 'PID',
		plid: 'PLID',
		productrevieworganization: '产品审核机构',
		productImg: '产品图片',
		dataPublicType: '数据公开类型',
		quantity: '数量',
		mobile: '电话',
		testPrcie: '检测价格',
		testCycle: '检测周期',
	},
	radar_chart: {
		feel: '手感',
		skin: '皮肤舒适度',
		skin_discomfort: '皮肤不适感',
		heat: '热湿舒适度',
		softness: '柔软度',
		stiff: '硬度',
		roughness: '粗糙度',
		smoothness: '光滑度',
		warmth: '暖和度',
		total: '综合',
		prickle: '刺痛度',
		comfort_value: '热舒适感',
		dampness_sensation: '湿感',
		thermal_sensation: '热感',
		average: '均值',
		footprint: '碳足迹',
		recyclable: '可循环指标',
		composition: '成分',
		art: '美学舒适性',
		layer: '结构层',
	},
	login: {
		helloWord: '开启您数字化转型航程',
		title: '您好，欢迎来到FBD！',
		subtitle: '登录并继续下一步',
		companyOgn: '公司/组织',
		enter: '输入',
		username: '用户名',
		password: '密码',
		check_password: '确认密码',
		forgetpassword: '忘记密码',
		remember: '记住我',
		login: '登录',
		register: '去注册',
		registercomplete: '注册并完善信息',
		hint_username: '请输入用户名',
		hint_password: '请输入密码',
		logout_title: '确定退出吗？',
		noAccount: '我没有账户.',
		chinese: '中文',
		english: 'English',
		email: '电子邮箱',
		next: '下一步',
		message1: '电子邮箱将作为您的账户',
		message2: '请按住滑块，拖动到最右边',
		message3: '验证通过',
		message4: '验证邮件已发送，您可以通过邮件设置您的密码！',
		message5: '我已阅读并接受',
		message6: '《使用条款》',
		message7: '至少包含一个大写字母，小写字母，数字和特殊字符，长度至少8位, ex:Ft12345#', // @$!%*?&#
		message8: '两次密码输入不一致',
		message9: '请仔细阅读使用条款，并选中选框',
		message10: '请输入正确的邮箱',
		message11: '请完成滑块验证',
		message12: '验证邮件已发送，您可以通过邮件重置您的密码！',
		title1: '注册',
		title2: '重置密码',
		message13: '注册成功',
		confirm: '确认',
		agreeAndContinue: '同意并继续',
		title3: '重置邮箱',
		message14: '输入原账户密码校验',
		message15: '邮箱修改成功',
		newEmail: '新邮箱',
		refeshPicture: '更换图片',
		bar1: '按住滑块，拖动完成上面拼图',
		bar2: '用时',
		bar3: '验证失败',
		bar4: '完成拼图',
		message16: '请输入注册电子邮箱',
		message17: '2s后跳转至信息完善页',
		outTime: '该链接已过期，请重新填写注册信息',
		outTime1: '该链接已过期，请重新填写重置密码信息',
	},
	dashboard: {
		name: '主页',
		title: '主页',
		input1: 'PID/产品名称',
		input2: 'OID/公司名称',
		input3: '质量指标名称',
		input3_1: '指标名称',
		input4: 'PLID/产品线名称',
		input5: 'PLID/产品线名称/指标名称',
		input6: '搜索检测机构/检测机构OID/指标名称',
		input7: '搜索产地、供应商',
		selectedLength: '最多选择5条数据',
		selectedLength3: '最多选择3条数据',
		hScodedescription: 'HS Code描述',
		batchtotalquantity: '批次总量',
		supplier: '商家名称',
		organizationStructure: '组织结构',
		listingTime: '上架时间',
		evaluate: '评价',
		indicatorValues: '指标数值',
		Indicatorunit: '指标单位',
		Testingcertificate: '检测证书',
		TestingDate: '检测日期',
		Identificationtestinginstitution: '检测机构二维码',
		Certificationdate: '检测日期',
		Validitycertification: '检测机构资质认证截止有效期',
		Certificationbody: '检测机构资质认证机构',
		Clicktoview: '点击查看',
		dataBaseType: '产品类型/目标市场',
		fillDataMessage: '请完善所有数据再搜索',
		fillDataMessage1: '请选择产品类型/目标市场和HS Code再搜索',
		indicatorInformation: '指标信息',
		weight: '权重',
		value: '值',
		avg_value: '均值',
		total_pef: 'PEF总值',
		total_esg: 'ESG总值',
		total_circularity: '循环性总值',
		quality_traceability_diagram: '质量追溯图',
		view_indicators: '查看指标',
		special_indicators: '特殊指标',
		quality: {
			title: '质量仪表板',
			titleText: '产品数字护照：质量',
			titleText1: '法规/贸易所需的质量指标清单',
			titleText2: '按质量指标搜索产品',
			titleText3: '按质量指标搜索检测机构',
			mainTitle: '产品质量性能比较',
			titleText4: '产品质量指标加权排名',
			message: '权重比例之和不等于100%!',
			message1: '权重比例不能为0!',
			titleText5: '总体质量评级',
			titleText5_new: '质量指标总体表现',
			special_functional_indicators: '质量特殊指标',
			titleText6: '0%指标通过率',
			titleText7: '100%指标通过率',
			special_indicators: '特殊指标',
			titleText8: '产品总体质量等级',
			titleText9: '市场平均质量等级',
			titleText10: '质量认证',
			performance_of_Quality_Indicator_Grouping: '质量指标分组表现',
			numerical_performance_of_quality_indicators: '质量指标搜索-产品指标列表',
			product_Database: '质量指标搜索-产品列表',
			inputtext: '指标类型',
			selectLegnth: '列已选择',
			weightRatio: '权重配比',
			tableHeader1: '法规/贸易质量指标',
			tableHeader2: '检测机构名称',
			tableHeader3: '检测机构名称OID',
			tableHeader5: '公司OID',
			tableHeader6: 'PID二维码',
			tableHeader7: '指标组',
			tableHeader8: '机构二维码',
			tableHeader9: '检测机构二维码',
			tableHeader10: '检测价格',
			tableHeader11: '检测周期（天）',
			tableHeader12: '公司链接',
			tableHeader13: '电子邮箱',
			tableHeader14: '指标分组',
			form_contacts: '联系人',
			mobile: '联系电话',
			pass: '通过',
			fail: '未通过',
			quality_index_query: '质量指标查询',
			quality_traceability_diagram: '质量追溯图',
		},
		environment: {
			title: '环境足迹仪表板',
			titleText: '产品数字护照：环境足迹',
			titleText1: '法规/贸易所需的环境足迹指标清单',
			titleText2: '按环境足迹指标搜索产品',
			titleText3: '按环境足迹指标搜索检测机构',
			mainTitle: '环境足迹指标比较',
			titleText4: '产品环境足迹指标加权排名',
			titleText6: 'PEF=0',
			titleText7: '公开市场的最大PEF',
			titleText8: '产品环境足迹（PEF）总体等级',
			titleText9: '产品环境足迹（PEF）市场平均等级',
			titleText5_new: '环境指标总体表现',
			special_environmental_indicators: '环境特殊指标',
			performance_of_pef_Indicator_Grouping: '环境足迹指标分组表现',
			numerical_performance_of_environmental_indicators: '环境足迹指标搜索-产品列表',
			Performance_subgroups_in_the_climate_index_group: '环境足迹指标搜索-产品指标列表',
			passport_tableHeader1: '影响类别',
			passport_tableHeader2: '等级',
			passport_tableHeader3: '正常结果',
			passport_tableHeader4: '权重结果',
			passport_tableHeader5: 'PEF综合结果',
			tableHeader15: 'PEF综合指标',
			tableHeader16: '指标等级',
			tableHeader17:'PEF值',
			tableHeader18: '同类产品PEF排名',
			environment_index_query: '环境指标查询',
			pef_value: 'PEF值',
			quality_traceability_diagram: '环境足迹追溯图',
		},
		esg: {
			title: 'ESG仪表板',
			titleText: '产品数字护照：ESG',
			titleText1: '法规/贸易所需的ESG指标清单',
			titleText2: '按ESG指标搜索产品',
			titleText3: '按ESG指标搜索检测机构',
			mainTitle: 'ESG指标比较',
			titleText4: '产品ESG指标加权排名',
			titleText5: '产品ESG等级',
			titleText6: '0%指标性能低',
			titleText7: '100%指标性能高',
			titleText8: '产品ESG总体等级',
			titleText9: '产品ESG市场平均等级',
			titleText10: 'PEF认证',
			titleText5_new: 'ESG指标总体表现',
			special_environmental_indicators: 'ESG特殊指标',
			performance_of_pef_Indicator_Grouping: 'ESG指标分组表现',
			numerical_performance_of_environmental_indicators: 'ESG指标搜索-产品列表',
			Performance_subgroups_in_the_climate_index_group: 'ESG指标搜索-产品指标列表',
			tableHeader15: 'ESG综合指标',
			esg_index_query: 'ESG指标查询',
			esg_value: 'ESG综合指标',
			quality_traceability_diagram: 'ESG追溯图',
			esg_normalized_average: 'ESG归一化平均值',
			esg_normalized_index_value: 'ESG归一化指标值',
		},
		circularity: {
			title: '循环性仪表板',
			titleText: '产品数字护照：循环性',
			titleText1: '法规/贸易所需的循环性指标清单',
			titleText2: '按循环性指标搜索产品',
			titleText3: '按循环性指标搜索检测机构',
			mainTitle: '循环性指标比较',
			titleText4: '产品循环性指标加权排名',
			titleText5: '产品循环性等级',
			titleText6: '0%指标性能低',
			titleText7: '100%指标性能高',
			titleText8: '产品循环性总体等级',
			titleText9: '产品循环性市场平均等级',
			titleText5_new: '循环性指标总体表现',
			special_environmental_indicators: '循环性特殊指标',
			performance_of_pef_Indicator_Grouping: '循环性指标分组表现',
			numerical_performance_of_environmental_indicators: '循环性指标搜索-产品列表',
			Performance_subgroups_in_the_climate_index_group: '循环性指标搜索-产品指标列表',
			tableHeader15: '循环性综合指标',
			circularity_index_query: '循环性指标查询',
			circularity_value: '循环性综合指标',
			quality_traceability_diagram: '循环性追溯图',
			circularity_normalized_average: '循环性归一化平均值',
			circularity_normalized_index_value: '循环性归一化指标值',
		},
		comfort:{
			title: '感官舒适性仪表板',
			titleText: '产品数字护照：感官舒适性',
			titleText1: '法规/贸易所需的感官舒适性指标清单',
			titleText2: '按感官舒适性指标搜索产品',
			titleText3: '按感官舒适性指标搜索检测机构',
			mainTitle: '感官舒适性指标比较',
			titleText4: '产品感官舒适性指标加权排名',
			titleText5: '产品感官舒适性等级',
			titleText6: '0%指标性能低',
			titleText7: '100%指标性能高',
			titleText8: '产品感官舒适性总体等级',
			titleText9: '产品感官舒适性市场平均等级',
			titleText10: 'PEF认证',
			titleText5_new: '感官舒适性指标总体表现',
			special_environmental_indicators: '感官舒适性特殊指标',
			performance_of_pef_Indicator_Grouping: '感官舒适性指标分组表现',
			numerical_performance_of_environmental_indicators: '感官舒适性指标搜索-产品列表',
			Performance_subgroups_in_the_climate_index_group: '感官舒适性指标搜索-产品指标列表',
			comfort_index_query: '感官舒适性指标查询',
			circularity_value: '感官舒适性综合指标',
			quality_traceability_diagram: '感官舒适性追溯图',
			comfort_normalized_val: '舒适性归一化值',
			product_name: '产品名称',
			fabric_name: '织物名称',
		},
		traceability:{
			title: '可追溯性仪表板',
			titleText: '产品数字护照：可追溯性',
			mainTitle: '产品列表',
			placeholder1: '请选择数据公开类型',
			titleText6: '0%指标性能低',
			titleText7: '100%指标性能高',
			titleText5_new: '可追溯性指标总体表现',
			special_environmental_indicators: '可追溯性特殊指标',
			performance_of_pef_Indicator_Grouping: '可追溯性指标分组表现',
			origin_traceability_map: '产地追溯图',
			traceability_map: '可追溯性追溯图',
			origin_traceability: '产地追溯',	
		},
	},
	garment: {
		name: '服装',
		title: '服装列表',
		add: '新增服装信息',
		edit: '编辑服装信息',
		detail: {
			title: '服装文件信息',
		},
		version: '服装版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
	},
	fabric: {
		name: '织物',
		title: '织物列表',
		add: '新增织物信息',
		edit: '编辑织物信息',
		comfortable_base: "舒适性基本信息",
		detail: {
			title: '织物文件信息',
			water: '织物水分传导功能',
			membrane: '膜性能',
			disguised: '相变资料',
			heat: '自加热',
			ftt: 'FTT织物触觉测试',
			liquid_water_conductivity: '织物液态水分传导性能',
			sst: '上层扩散速度',
			ssb: '底层扩散速度',
			r: '单向传输指数',
			ommc: '综合吸湿性能',
			top_water_contact_angle: '上层水接触角',
			bottom_water_contact_angle: '底层水接触角',
		},
		no_layers: '织物编号',
		id: '织物ID',
		structure: '织物结构',
		structure_layer: '织物结构层',
		color: '织物颜色',
		thickness: '织物厚度',
		thickness_unit: 'cm',
		weight: '织物重量',
		weight_unit: 'g/m2',
		density: '织物密度',
		density_unit: 'g/m3',
		tortuous: '织物曲隙率',
		porosity: '织物孔隙率',
		keyword_placeholder: 'ID/名称/类型/供应商',
		tips: '纺织品织物触感检测与评价方法多指标集成法FZ/T 01166-2022'
	},
	yarn: {
		name: '纱线',
		title: '纱线列表',
		add: '新增纱线信息',
		edit: '编辑纱线信息',
		detail: {
			title: '纱线文件信息',
		},
		id: '纱线ID',
		percentage: '纱线比例',
		percentage_unit: '%',
		type: '纱线类型',
		linear_density: '纱线线密度',
		linear_density_unit: 'tex',
		diameter: '纱线直径',
		diameter_unit: 'mm',
		twist: '纱线捻度',
		twist_unit: 'twist/meter',
		keyword_placeholder: 'ID/类型/供应商/品牌',
	},
	hscode: {
		name: 'HS Code',
		title: 'HSCODE管理',
		description: 'HS Code是针对系统中产品各项标准的集合',
		parentclassencoding: '父类编码',
		encodingtype: '编码分类',
		encodingName: '编码名称',
		add: '新增HS Code',
		edit: '编辑HS Code',
		delete: '删除HS Code',
		searchPlaceholder: '搜索HS Code编码',
		addIndicator: '添加指标',
		addIndicator1: '添加属性',
		indicatorName: '指标名称',
		indicatorName1: '标准名称',
		groupName: '组名称',
		category_name: '指标类别',
		deleteGroup: '删除组',
		dataBase: '归属数据库',
		detailTitle: 'HS Code管理',
		encodingId: '编码ID',
		filterHscode: '筛选HS Code名称',
		requiredHscode: '请选择HS Code',
		requireProduct: '请选择产品审核机构', //Product review organization
		requiredIndicatorName: '请填写指标信息',
		requiredIndicatorFile: '请上传指标报告附件',
		requirePID: '请填写PID', //Product review organization
		requirePLID: '请填写PLID', //Product review organization
		descriptionLong: '描述输入长度不能超过200',
		createProductsAtThisLevel: '以此层级创建HS Code',
		message: '请填写4位数字',
		message1: '请填写6位数字',
		messageLength: '请填写正确的长度',
		hsCodeFourLength: '4位HS Code',
		hsCodeSixLength: '6位HS Code',
		message2: '请填写产品大类的名称',
		subItemCode: '子项编码',
		fill: '请填写',
		productCode: '产品代号',
		indexClassification: '指标分类',
		add_indicator_type:'新增指标类型',
		delete_indicator_type:'删除指标类型',
		add_group_type:'添加指标组',
		group_type_name: '指标组名称',
		delete_group_type:'删除指标组',
		add_group_son_type:'添加指标子组',
		group_son_type_name: '指标子组名称',
		delete_group_son_type:'删除指标子组',
		threshold:'阈值',
		standard_judgment_method:'达标判断方式',
		is_it_applicable:'是否适用',
		is_special_indicator:'是否特殊指标',
		type:{
			yes: '是',
			no: '否',
		},
		calculation_mode: '计算方式',
		sameGroupName: '指标组名重复',
		sameSubGroupName: '指标子组名重复',
		same_category_name: '指标类型重复',
		same_group_subGroup_name: '指标组名或指标子组名重复',
		target_market: '目标市场',
		target_market_description: '目标市场会将HS Code划分为不同的地区版本，建议在最底层填写',
		target_market_code: '目标市场代码',
		target_market_code_description: '填写目标市场代码，代码将作为PID重要组成内容',
		needInfo: '是否适用为是的时候，需要填些阈值和达标方式',
		indicator_group: '指标组', //指标组
		indicator_sub_group: '指标子组',
		expand: '展开',
		collapse: '收起',
	},
	product_template: {
		title: '产品数据库管理',
		add: '添加产品数据库',
		searchPlaceholder: '搜索产品模板名称',
		searchPlaceholder1: '搜索HS Code、目标市场',
		templateName: '模板名称',
		productTemplateName: '产品模板名称',
		productTemplateName1: '数据库名称',
		update_time: '最近修改时间',
		template_info: '产品附加信息',
		hscodeDatabase: 'HS Code数据库',
		hscodeDatabase1: 'HS Code',
		description: '描述',
		publicType: '数据公开类型',
		plid: 'PLID',
		pid: 'PID',
		productrevieworganization: '产品审核机构',
		addField: '添加字段',
		productInfo: '产品信息',
		comfortInformation: '舒适度信息',
		qualityInspectionReport: '质检报告',
		otherInfo: '其他信息',
		basicInfo: '基本信息',
		productName: '产品名称',
		type: '类型',
		inventory: '库存',
		price: '价格',
		size: '尺寸',
		color: '颜色',
		batch: '批次号',
		batchValue: '批次量',
		compositionStructure: '组成结构',
		number: '编号',
		structure: '结构',
		proportion: '比例',
		searchProducts: '搜索',
		selectDataBase: '请选择产品数据库',
		productImg: '产品图片',
		text: '文本名称',
		thermalComfortDat: '热湿舒适度 dat文件',
		heatandhumiditycomfort: '热湿舒适度',
		ftt: 'FTT织物触觉测试',
		liquid_water_conductivity: '织物液态水分传导性能',
		bottom_water_contact_angle: '底层水接触角',
		membrane: '膜性能',
		disguised: '相变资料',
		heat: '自加热',
		enterFieldName: '字段名称',
		requeiredInfo: '请输入字段名称！',
		requeiredInfo1: '请输入',
		requeiredInfo2: '自定义字段名称！',
		requeiredproductInfoFieldName: '请输入产品信息自定义字段名称！',
		requeiredcomfortInfoFieldName: '请输入舒适度信息自定义字段名称！',
		requeiredotherInfoFieldName: '请输入其他信息自定义字段名称！',
		targetmarket: "目标市场",
		requeiredcompositionStructureValue: '请选择组成结构信息！',
		noTemplateInfo: '未查询到此模板信息!',
		upload_info: '支持png、jpeg、jpg、dwg、dwt、dxf、dwf、mp4、mov、avi文件大小不超过50M',
		testingOrganization: '检测机构',
		testingOrganizationQualification: '检测机构资质',
		report: '报告',
		report1: '检测报告',
		remark: '备注',
		requeiredindicatorstandards: '请填写所有指标分组信息',
		origin: '产地',
		productLine: '生产线名称',
		productLineNo: '生产线编号',
		productTime: '生产时间',
		requireCompositionStructure: '请完善组成结构信息',
		compositionStructureSum: '组成结构比例之和不能超过100',
		compositionStructureError: '组成结构只有一项时请选择内衬',
		requireupload: '请完善上传图片信息',
		annex: '附件',
		createTimeRange: '创建时间范围',
		requiredIndicato1: '请选择指标',
		dataBaseNoOpen: '该产品数据库未启用',
		checkerr: '组成结构为空时不能勾选必填项',
		warningInfo: '关闭数据库后，将下架使用此模版的所有产品！',
		testDate: '检测日期',
		testinginstitutions: '检测机构资质认证截止有效期',
		testinginstitutions1: '检测机构资质认证机构',
		deleteTitle: '删除模板数据将删除数据库下的所有产品数据，且这些数据不可找回，请谨慎删除',
		integerMessage: '库存或批次量请填写≥0的整数',
		priceMessage: '价格请填写≥0的整数或小数，小数保留长度不超过2位',
		repeatMessage: '模块名称重复'
	},
	products: {
		title: '产品',
		title1: '产品列表',
		name: '产品名称',
		add: '创建产品',
		subtitle: '服装产品',
		searchPlaceholder: '搜索产品',
		supplier: "商家",
		pubnishTime: '发布时间',
		customerReview: '顾客评价',
		order: '成交数量',
		availableStocks: "可用库存",
		description: '产品描述',
		basicInfo: '基本信息',
		productdetails: '产品详情',
		size: '尺寸',
		color: '颜色',
		all: '全部',
		notpublic: '不公开',
		Opasc: '供应链公开',
		completelypublic: '完全公开',
		uploadMuti: '批量上传',
		message1: '请输入报告中的检测机构名称',
		message2: '请输入报告中的检测机构资质',
		loseTemplateName: '缺少模板名称',
		status: '审核状态',
		message3: '请输入认证日期',
		message4: '请输入检测机构资质认证截止有效期',
		message5: '请输入检测机构资质认证机构',
		message6: '没有该数据库权限',
		message7: '没有该HS Code产品线',
		message8: '复制的产品与原产品将存在PID冲突，请注意修改',
		advanced_search: '高级搜索',
	},
	account: {
		title: '企业账户管理',
		title1: '我的审核信息',
		subtitle: '注册会员',
		info: '我们需要收集您的企业信息以便为您提供更好的使用体验',
		info1: '去完善信息',
		progressInfo1: '账户信息',
		progressInfo2: '企业/组织信息',
		progressInfo3: '提交申请',
		form_companyName: '公司名称',
		form_companyName_placeholder: '请输入公司/组织名称',
		form_username_placeholder: '请输入账户邮箱',
		form_email_placeholder: '请输入联系人邮箱',
		form_Enterprisetype: '企业类型',
		form_Enterprisetype_placeholder: '请选择您的企业类型',
		form_contacts: '联系人全名',
		form_contacts_name: '名', //请输入联系人全名
		form_contacts_xing: '姓',
		form_email: '联系人邮箱',
		form_phone: '座机号码',
		form_phone_number: '手机号码',
		form_main_business_areas: '主要经营领域',
		form_main_business_areas_placeholder: '请选择您的主要经营领域',
		from_is_certification_company: '是否认证机构',
		from_is_check_company: '是否检测机构',
		from_is_certification_company_placeholder: '请选择是否认证机构',
		from_is_check_company_placeholder: '请选择是否检测机构',
		form_Enterprise_registered_address: '企业注册地址',
		form_Certificate_No: '证书编号',
		form_qualification_documents: '资质文件',
		form_country: '国家',
		form_province: '省/直辖市',
		form_province_code: '省/直辖市代码',
		form_province_code_placeholder: '请输入大写字母格式的代码',
		form_City: '市/区',
		form_address: '详细地址',
		form_post: '邮编',
		enterprise_production_address: '企业生产地址',
		contact_address: '企业通讯地址',
		btn_add_production_address: '添加生产地址',
		btn_back: '返回',
		btn_submit: '提交',
		btn_submit_success: '提交成功',
		progressInfo4: '您的申请已提交，我们会在三个工作日内完成审核，请您耐心等待！',
		progressInfo5: '您所提交的信息不能够证明您在行业中的角色，请您提供完整的企业信息！',
		btn_complete: '完善信息',
		logo: '企业标志',
		progressInfo6: '您所提交的信息已审核通过',
		rejectReason: '驳回原因',
		no_wait_review_info: '暂无审核信息',
		backToLogin: '返回至登录页',
		contactAddress: '联系人通讯地址',
		form_qualification_certification: '机构资质认证截止有效期',
		form_qualification_certification1: '机构资质认证机构',
		form_company_link: '公司官网网址',
		form_test_date_placeholder1: '请选择机构资质认证截止有效期',
		form_test_date_placeholder2: '请输入机构资质认证机构',
		form_test_date_placeholder3: '请输入公司的网站链接',
		tab1: '检测价格配置',
		product_address_info: '制造商、供应商需要填写完整的生产地址信息',
	},
	supplyChain: {
		placeholder1: '搜索供应链名称',
		placeholder2: '供应链类型',
		placeholder3: '选择供应链启动时间',
		tableHeader1: '供应链名称',
		tableHeader1_1: '公司名称',
		tableHeader2: '供应链启动时间',
		tableHeader3: '供应链关闭时间',
		add: '添加供应链',
		edit: '编辑供应链',
		detail: '供应链详情',
		setting: '供应链配置',
		setting_role: '供应链角色',
		name: '供应链',
		company_name_repeat: '公司名称重复',
	},
	business_information_management: {
		title: '商业用户管理',
		subtitle: '商业用户审批',
		subtitle11: '商业用户审批列表',
		subtitle1: '商业用户审批详情',
		subtitle2: '商业用户详情',
		search_placeholder: '搜索公司名称、联系人、电话',
		search_placeholder1: '选择注册日期',
		search_placeholder2: '选择企业类型',
		search_placeholder3: '选择企业注册地',
		tab1: '待审批',
		tab2: '未通过',
		tab3: '已通过',
		registre_time: '注册日期',
		newUser: '新用户',
		examine: '账户信息审核',
		examine1: '企业/组织信息审核',
		examine2: '权限配置',
		examine3: '审核意见',
		examine4: '驳回申请',
		viewfile: '查看附件',
		thirdCompany: '认证机构',
		testingOrganization: '检测机构',
		lastLoginTime: '上次登录时间',
		passport: '数字组织护照',
		detail_tab1: '企业信息',
		detail_tab2: '权限信息',
		rejectedsuccessfully: '驳回成功',
		please_input_reject_reason: '请输入驳回原因',
		functionalpermissions: '功能权限',
		noUserPermissions: '未配置用户权限',
		examineSuccess: '用户审核成功',
		examineing: '审核中',
		accountEmail: '账户邮箱',
		disableAccount: '确认禁用此账户？',
		disableAccountResult: '禁用后用户将无法登录系统！',
	},
	business_products_management: {
		title: '产品认证管理',
		subtitle: '产品列表',
		subtitle1: '产品信息审批详情',
		subtitle2: '产品信息详情',
		search_placeholder: '搜索公司/组织名称',
		search_placeholder1: '选择提交日期',
		tab1: '未审核',
		tab2: '未通过',
		tab3: '检测已通过',
		tab4: '认证已通过',
		tableHeader1: '公司/组织名称',
		tableHeader2: '提交日期',
		reject: '不通过',
		testedSuccessfully: '通过检测',
		certificationPassed: '通过认证',
		reject_reason: '不通过原因',
		input_reject_reason: '请输入不通过原因',
		passed_successfully: '审核通过',
		delete_alert_title: '确定删除该产品么?',
		delete_alert_info: '此操作将删除用户提交的产品，请谨慎操作！',
		updatedHSCode: '更新了HS Code',
		updatedTemplate: '更新了模板',
	},
	product_line: {
		title: '产品线管理',
		subTitle: '产品线管理',
		searchPlaceholder: '搜索产品线名称、目标市场',
		searchPlaceholder1: '产品类型',
		searchPlaceholder1_1: '请选择产品类型',
		searchPlaceholder2: '请选择HS Code',
		table_header: '产品线编号',
		table_header_searchPlaceholder: '请输入6位编号,大写字母和数字组合',
		table_header1: '产品线名称',
		table_header1_searchPlaceholder: '请输入产品线名称',
		table_header2: 'PLID',
		table_header3: '成品样式',
		table_header4: '设计版型',
		table_header5: 'HS Code',
		table_header6: '产地',
		table_header7: '目标市场',
		searchPlaceholder3: '请选择目标市场',
		add: '创建产品线',
		upload_info: '支持.png,.jpeg,.jpg,.dwg,.dwt,.dxf,.dwf,.mp4,.mov,.avi文件，文件大小不超过50M',
		product_line_no_length: '请填写6位长度产品线编号',
		modify_product_line: '编辑产品线',
		product_line_detail: '产品线详情',
		message: '平台管理要求，需补录部分内容以完善产品信息',
		seach_product_line_name: '搜索产品线名称',
	},
	fiber: {
		name: '纤维',
		title: '纤维列表',
		add: '新增纤维信息',
		edit: '编辑纤维信息',
		detail: {
			title: '纤维文件信息',
		},
		id: '纤维ID',
		type: '纤维类型',
		percentage: '纤维比例',
		percentage_unit: '%',
		density: '纤维密度',
		density_unit: 'g/cm3',
		diameter: '纤维直径',
		diameter_unit: 'mm',
		thermal_conductivity: '纤维热导率',
		thermal_conductivity_unit: 'W/(m*k)',
		moisture_regain: '回潮率',
		moisture_regain1: '回潮率',
		water_contact_angle: '接触角',
		water_contact_angle_unit: 'deg',
		water_diffusion_coefficient: '水扩散系数',
		water_diffusion_coefficient_unit: 'm2/s',
		relative_humidity: '相对湿度',
		keyword_placeholder: 'ID/类型/供应商/品牌',
	},
	hometextile: {
		name: '家纺',
		title: '家纺列表',
		add: '新增家纺信息',
		edit: '编辑家纺信息',
		detail: {
			title: '家纺文件信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
	},
	textile: {
		name: '产业纺织品',
		title: '产业纺织品列表',
		add: '新增产业纺织品信息',
		edit: '编辑产业纺织品信息',
		detail: {
			title: '产业纺织品文件信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
	},
	textile_kitchen: {
		name: '厨卫用品',
		title: '厨卫用品列表',
		add: '新增厨卫用品',
		edit: '编辑厨卫用品',
		detail: {
			title: '厨卫用品信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
		parent: '产业纺织品数据库',
	},
	textile_bedware: {
		name: '床上用品',
		title: '床上用品列表',
		add: '新增床上用品信息',
		edit: '编辑床上用品信息',
		detail: {
			title: '床上用品信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
		parent: '家纺数据库',
	},
	textile_home_decor: {
		name: '普通家用纺织品',
		title: '普通家用纺织品列表',
		add: '新增普通家用纺织品信息',
		edit: '编辑普通家用纺织品信息',
		detail: {
			title: '普通家用纺织品信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
		parent: '家纺数据库',
	},
	textile_industrial: {
		name: '产业纺织品',
		title: '产业纺织品列表',
		add: '新增产业纺织品信息',
		edit: '编辑产业纺织品信息',
		detail: {
			title: '产业纺织品信息',
		},
		version: '产品版型',
		keyword_placeholder: 'ID/名称/类型/供应商/品牌',
		parent: '产业纺织品数据库',
	},
	role: {
		name: '角色',
		title: '角色列表',
		add: '新增角色信息',
		edit: '编辑角色信息',
		detail: {
			title: '角色信息',
		},
		keyword_placeholder: '角色名称',
		hint_role_name: '角色名称不能为空',
		emptyRole: "请先创建角色"
	},
	user: {
		name: '用户',
		title: '用户列表',
		add: '新增用户信息',
		edit: '编辑用户信息',
		detail: {
			title: '用户信息',
		},
		keyword_placeholder: '用户名称',
		hint_name: '名称不能为空',
		hint_user_name: '用户名称不能为空',
		hint_password: '密码不能为空',
		hint_role: '角色不能为空',
	},
	permission: {
		name: '权限',
		title: '权限',
		role: '角色列表',
		permission: '权限列表',
	},
	lang:{
		functional_classification: '功能分类',
		menu: '菜单',
		home: '主页',
		hscode: 'HS Code',
		product_template: '产品数据库管理',
		products: '产品管理',
		business_information_management: '商业用户管理',
		business_products_management: '产品认证管理',
		product_line: '产品线管理',
		account: '企业账户管理',
		supplyChain: '供应链管理',
		search: '搜索',
		key: '键名',
		description: '描述',
		ch: '中文',
		en: '英文',
	},
	smooth: '光滑',
	rough: '粗糙',
	soft: '柔软',
	stiff: '硬挺',
	prickle: '刺痛',
	cool: '凉爽',
	warm: '温暖',
	comfortable: '舒适',
	uncomfortable: '不舒适',
	discomfort: '不舒适',
	dry: '干燥',
	damp: '潮湿',
	garmentProfile: '服装信息',
	fabricProfile: '织物信息',
	yarnProfile: '纱线信息',
	fibreProfile: '纤维信息',
	homeTextileProfile: '家纺信息',
	industrialTextileProfile: '产业纺织品信息',
}